import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
// import $ from 'jquery'

import DestinationActions from '../../Redux/DestinationRedux'
import CreateMapping from '../../Containers/Destination/CreateMapping'
import ViewMapping from '../../Containers/Destination/ViewMapping'

class Mapping extends React.Component {
  constructor (props) {
    super (props)
    let countries = []
    props.country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })
    this.country_list = countries
    this.state = {
      showModal: null,
      continent: '0',
      detail: []
    }
  }

  _toggleModal = (modalId = null, item = []) => {
    this.setState({showModal: modalId, detail: item})
  }

  componentDidMount = () => {
    this.props.getContinent()
  }

  render() {
    const { destination } = this.props

    return (
      <div>
        <header className="section">
          <div className="title-block d-flex mb-3">
            <h3 className="title mr-auto">
              Continent Mapping
              {destination.fetching && 
                <div className="badge badge-info ml-2">Loading ...</div> 
              }
            </h3>
            <button className="btn btn-primary ml-auto" onClick={() => this._toggleModal('create')}>Create Mapping</button>
          </div>
          <div className="title-block">
            {/* <p className="title-description">Filter:</p> */}
            <div className="form-inline">
              <div className="form-group">
                <label className="control-label mr-2">Continent</label>
                <select className="form-control" value={this.state.continent} onChange={(event) => this.setState({ continent: event.target.value })}>
                  <option value="">- Select Continent -</option>
                  {destination.continent && destination.continent.map((item, i) => (
                    <option key={i} value={i}>{ item.name || '-' }</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </header>
        <section className="section">
          <div className="card">
            {!(destination.fetching || destination.processing) && destination.err &&
              <div className="alert alert-danger">{destination.err}</div> 
            }
            
            { (this.state.continent && destination.continent.length) ?
              <div className="card-block">
                <table className="table table-hover table-striped" style={{ minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th>Country</th>
                      <th width="60%">Destinations</th>
                      <th className="text-center">Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {destination.continent[this.state.continent].countries.map((item, i) => (
                      <tr key={i}>
                        <td>{ item.name || '-' }</td>
                        <td>
                          { item.destinations.map((dest, i) => {
                            if (i === 0) {
                              return dest.name
                            } else {
                              return ", " + dest.name
                            }
                          }) }
                        </td>
                        <td className="text-center">
                          <button className="btn btn-primary" onClick={() => this._toggleModal('view', item)}>
                            <i className="fas fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              :
              null
            }
          </div>
        </section>

        {/* CREATE MAPPING */}
        <Modal open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateMapping closeModal={() => this._toggleModal()}/>
        </Modal>

        {/* VIEW DESTINATION */}
        <Modal open={this.state.showModal === 'view'} onClose={this._toggleModal} closeOnOverlayClick>
          <ViewMapping detail={this.state.detail} closeModal={() => this._toggleModal()}/>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  destination: state.destination,
  country_list: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  getContinent: () => dispatch(DestinationActions.continentRequest()),
})

export default connect(stateToProps, dispatchToProps)(Mapping)



// WEBPACK FOOTER //
// ./src/Pages/Destination/Mapping.js